import objGet from './utilities/object/objGet.js';
import set from './utilities/object/objSet.js';
import objSort from './utilities/object/objSort.js';
import clone from './utilities/object/objClone.js';
import { mergeDeep } from 'immutable';
import objOnly from './utilities/object/objOnly.js';
import objExcept from './utilities/object/objExcept.js';
import objMap from './utilities/object/objMap.js';
import flatten from './utilities/object/objFlatten.js';

/**
 * Object Class Handler
 *
 * @export
 * @class Obj
 */
var Obj = /** @class */ (function () {
    function Obj() {
    }
    /**
     * Set the given value to the given key
     * The key is a dot.notation syntax
     *
     * @param  {object} object
     * @param  {string} key
     * @param  {any} value
     * @returns {object}
     */
    Obj.set = function (object, key, value) {
        return set(object, key, value);
    };
    /**
     * Get the value of the given key
     *
     * @param  {object} object
     * @param  {string} key
     * @param  {any} $default
     * @returns any
     */
    Obj.get = function (object, key, $default) {
        if ($default === void 0) { $default = null; }
        return objGet(object, key, $default);
    };
    /**
     * Clone the given object to new one
     *
     * @param {object} object
     * @return {object}
     */
    Obj.clone = function (object) {
        return clone(object);
    };
    /**
     * Merge all given objects into one BIG object
     *
     * @param {any} objects
     * @return {object}
     */
    Obj.merge = function () {
        var objects = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            objects[_i] = arguments[_i];
        }
        return mergeDeep.apply(void 0, objects);
    };
    /**
     * Sort the given object by its keys
     *
     * @param   {object} object
     * @returns {object}
     */
    Obj.sort = function (object) {
        return objSort(object);
    };
    /**
     * Get only the given keys from the given object
     *
     * @param   {object} object
     * @param   {array} keys
     * @returns {object}
     */
    Obj.only = function (object, keys) {
        return objOnly(object, keys);
    };
    /**
     * Get all object data except for the given keys
     *
     * @param   {object} object
     * @param   {array} keys
     * @returns {object}
     */
    Obj.except = function (object, keys) {
        return objExcept(object, keys);
    };
    /**
     * Get only the given keys from the given object
     *
     * @param   {object} object
     * @param   {array} keys
     * @returns {Array<any>}
     */
    Obj.map = function (object, callback) {
        return objMap(object, callback);
    };
    /**
     * Flatten the given object into one big fat object
     */
    Obj.flatten = function (object, separator, parent, root) {
        if (separator === void 0) { separator = "."; }
        if (parent === void 0) { parent = null; }
        if (root === void 0) { root = {}; }
        return flatten(object, separator, parent, root);
    };
    return Obj;
}());

export { Obj as default };
